import {
  CircularProgress,
  Paper,
  useMediaQuery,
} from "@material-ui/core";
import useStyles from "../style";

type Props = {
  hiraCountObject: any;
  isLoadingHiraCount: any;
  activeTab?: any;
  setActiveTab?: any;
};

const HiraCountSectionForFilters = ({
  hiraCountObject,
  isLoadingHiraCount,
  activeTab = 0,
  setActiveTab,
}: Props) => {
  const matches = useMediaQuery("(min-width:820px)");
  const smallScreen = useMediaQuery("(min-width:470px)");
  const classes = useStyles(matches)();
  const handleTabClick = (index: any) => {
    setActiveTab(index);
  };

  const sections = [
    // { title: "No. Of Risks", count: hiraCountObject?.totalRisks },
    // { title: "Generated", count: hiraCountObject?.totalConslidatedHira },
    // { title: "InWorkflow", count: hiraCountObject?.totalInWorkflowConsolidatedHira },
    // { title: "Steps Impacted", count: hiraCountObject?.totalSteps },
    // { title: "New HIRA(s)", count: hiraCountObject?.totalNewHira },
    // {
    //   title: "No. Of Significant HIRA(s)",
    //   count: hiraCountObject?.totalSignificantHira,
    // },
    { title: "Total HIRA", count: hiraCountObject?.totalHira },
    { title: "InWorkflow HIRA", count: hiraCountObject?.inWorkflowHira },
    {
      title: "Current Year HIRA(New)",
      count: hiraCountObject?.totalCurrentYearHira,
    },
    {
      title: "Significant Steps",
      count: hiraCountObject?.totalSignificantSteps,
    },
  ];

  return (
    <>
      {isLoadingHiraCount ? (
        <CircularProgress />
      ) : (
        <div className={classes.parentDiv}>
          {sections.map((section, index) => (
            <div
              key={index}
              className={classes.papermaincontain}
              style={{ marginBottom: "20px" }}
            >
              <p className={classes.headingText}>
                {section.title}
                {section.title === "Total HIRA" && (
                  <span
                    style={{
                      fontSize: "10px", // Tiny font size
                      color: "#737373", // Subtle gray color
                      marginLeft: "5px", // Spacing from the main text
                      display: "inline-block", // Ensures alignment
                    }}
                  >
                    (approved)
                  </span>
                )}
                {section.title === "Current Year HIRA" && (
                  <span
                    style={{
                      fontSize: "10px", // Tiny font size
                      color: "#737373", // Subtle gray color
                      marginLeft: "5px", // Spacing from the main text
                      display: "inline-block", // Ensures alignment
                    }}
                  >
                    (approved + inWorkflow)
                  </span>
                )}
              </p>

              <Paper
                elevation={5}
                className={classes.paper}
                style={{ height: "80%" }}
              >
                <div
                  className={`${classes.papercontainers} ${
                    activeTab === index ? classes.active : ""
                  }`}
                  style={{
                    cursor: "default", // Ensure no pointer cursor
                    color: "inherit", // Neutral color, no active tab highlight
                  }}
                >
                  <p className={classes.headingnumber}>{section.count}</p>
                </div>
              </Paper>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default HiraCountSectionForFilters;
